// src/store/selectors/user/index.ts

import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectUserState = (state: RootState) => state.user;

export const selectUser = createSelector(selectUserState, (state) => state.user);
export const selectNotifications = createSelector(selectUserState, (state) => state.notifications);
export const selectNotificationItems = createSelector(selectNotifications, (notifications) => notifications.items);
export const selectUnreadNotificationCount = createSelector(
  selectNotifications,
  (notifications) => notifications.unreadCount
);
export const selectUserFieldError = (field: string) =>
  createSelector(selectUserState, (state) => state.fieldErrors[field]);
